/**
 * ResearchSpace
 * Copyright (C) 2020, © Trustees of the British Museum
 * Copyright (C) 2015-2019, metaphacts GmbH
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.

 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

export { default as rdfs } from './rdfs';
export { default as rdf } from './rdf';
export { default as xsd } from './xsd';
export { default as dc } from './dc';
export { default as dct } from './dct';
export { default as crm } from './crm';
export { default as sp } from './sp';
export { default as spl } from './spl';
export { default as spin } from './spin';
export { default as ldp } from './ldp';
export { default as oa } from './oa';
export { default as field } from './field';

export { default as prov } from './prov';

export { default as persist } from './persist';
export { default as VocabPlatform } from './platform';

export { default as workflow } from './workflow';
